(() => {
  const withAnimations = (callback) => {
    if (window.PatineAnimationLoader) {
      window.PatineAnimationLoader.whenReady(callback);
      return;
    }

    if (window.PatineAnimations) {
      callback(window.PatineAnimations);
      return;
    }

    window.addEventListener('patine:animations-ready', (event) => callback(event.detail), { once: true });
  };

  const init = (PA) => {
    if (!PA || PA.prefersReducedMotion) return;

    const { gsap, registerSection, splitWords } = PA;
    const section = document.querySelector('.patine-hero');
    if (!section) return;

    const triggers = [];

    // 1. Parallax on hero image
    const img = section.querySelector('.patine-hero__img');
    if (img) {
      const parallax = gsap.to(img, {
        yPercent: -10,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      });
      triggers.push(parallax.scrollTrigger);
    }

    // 2. Text split reveal on heading
    const heading = section.querySelector('.patine-hero__heading');
    if (heading) {
      heading.classList.remove('patine-reveal');
      const words = splitWords(heading);
      const tl = gsap.timeline({ delay: 0.3 });
      tl.from(gsap.utils.toArray(words), {
        opacity: 0,
        y: 30,
        duration: 0.6,
        stagger: 0.06,
        ease: 'power2.out',
        clearProps: 'opacity,transform',
      });
    }

    // 3. Stagger entrance: badge -> subheading -> CTA
    const badge = section.querySelector('.patine-hero__badge');
    const sub = section.querySelector('.patine-hero__subheading');
    const cta = section.querySelector('.patine-btn');
    const staggerEls = [badge, sub, cta].filter(Boolean);

    if (staggerEls.length) {
      gsap.set(staggerEls, { opacity: 0, y: 20 });
      gsap.to(staggerEls, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.12,
        ease: 'power2.out',
        delay: 0.8,
        clearProps: 'opacity,transform',
      });
    }

    // Register for theme editor cleanup
    const wrapper = section.closest('[id^="shopify-section"]');
    if (wrapper) registerSection(wrapper.id, triggers);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => withAnimations(init));
  } else {
    withAnimations(init);
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.patine-hero')) withAnimations(init);
  });
})();
